import React from "react";

// Breadcrumbs disabled - component returns null
export default function BreadCrumb() {
  return null;
}
